import {
  LEGAL_COMERCIO_SECTIONS,
  type LegalComercioSectionId,
} from "../../content/legalComercio";
import { useLegalComercio } from "../../context/LegalComercioContext";

type FooterVariant = "light" | "onImage";

interface LegalComercioFooterProps {
  variant?: FooterVariant;
  className?: string;
}

export function LegalComercioFooter({
  variant = "light",
  className = "",
}: LegalComercioFooterProps) {
  const { openLegalModal } = useLegalComercio();

  const base =
    variant === "onImage"
      ? "border-white/20 bg-black/25 text-white/90 backdrop-blur-sm"
      : "border-gray-200 bg-white text-gray-600";

  const linkClass =
    variant === "onImage"
      ? "text-white underline-offset-2 hover:text-white hover:underline"
      : "text-[#1A3AB8] underline-offset-2 hover:underline";

  const open = (id?: LegalComercioSectionId) => (e: React.MouseEvent) => {
    e.preventDefault();
    openLegalModal(id);
  };

  return (
    <footer
      className={`shrink-0 border-t px-4 py-4 sm:px-6 ${base} ${className}`}
      role="contentinfo"
    >
      <div className="mx-auto flex max-w-4xl flex-col gap-3 text-center text-xs sm:text-sm">
        <p>
          <button type="button" onClick={open()} className={`font-medium ${linkClass}`}>
            Información legal y condiciones de compra
          </button>
        </p>
        <nav
          className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1"
          aria-label="Secciones legales"
        >
          {LEGAL_COMERCIO_SECTIONS.map((s, i) => (
            <span key={s.id} className="inline-flex items-center gap-3">
              {i > 0 && (
                <span className={variant === "onImage" ? "text-white/40" : "text-gray-300"}>
                  ·
                </span>
              )}
              <button type="button" onClick={open(s.id)} className={linkClass}>
                {s.title}
              </button>
            </span>
          ))}
        </nav>
        <p className={variant === "onImage" ? "text-white/60" : "text-gray-400"}>
          © {new Date().getFullYear()} Circuit Cover
        </p>
      </div>
    </footer>
  );
}
